// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"add57097","453":"e30e9376"}[chunkId] + ".chunk.js";
};